export const Error: view = ({
  errorMessage = observe.components[prop.parentId].data.error,
}) => <div>Error: {errorMessage}</div>;
